// custom typefaces
import "bootstrap/dist/css/bootstrap.min.css"
import "./static/fonts/icons/style.css"
import "./src/styles/style.scss"
import 'firebase/analytics';

import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider
